/**
 * Auth-aware fetch client for the Pro Garages OWNER PORTAL (super-admin).
 * Separate token so garage & admin sessions never collide.
 */
const BASE = process.env.REACT_APP_BACKEND_URL ?? "";
export const ADMIN_TOKEN_KEY = "pg_admin_access_token";

export async function adminApi(path, options = {}) {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY) || "";
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${BASE}/api${path}`, { ...options, headers });
  const text = await res.text();
  let body = null;
  try {
    body = text ? JSON.parse(text) : null;
  } catch {
    body = { raw: text };
  }
  if (!res.ok) {
    const message =
      typeof body?.detail === "string"
        ? body.detail
        : body?.detail?.message || body?.error || `HTTP ${res.status}`;
    const err = new Error(message);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

export async function adminDownload(path, fallbackName = "download") {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY) || "";
  const res = await fetch(`${BASE}/api${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    const t = await res.text();
    throw new Error(`Export failed (HTTP ${res.status}) ${t.slice(0, 120)}`);
  }
  const cd = res.headers.get("Content-Disposition") || "";
  const m = cd.match(/filename="?([^"]+)"?/);
  const name = m ? m[1] : fallbackName;
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = name; document.body.appendChild(a); a.click();
  a.remove(); URL.revokeObjectURL(url);
}
